@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load this nomination" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (NotFound) {
  <mj-empty-state Variant="empty" Title="This presentation isn't available" Message="If you expected it, reply to your OEP email or write to membership@agu.org."><div actions><button type="button" mjButton variant="primary" (click)="Back()">Back to your sessions</button></div></mj-empty-state>
} @else if (VM) {
<section class="oep-nomf" [attr.aria-busy]="Busy">
  <!-- markup.html:712 -->
  <button type="button" class="oep-nomf__back" (click)="Back()">← Your sessions</button>

  <!-- markup.html:713-719: submitted, or the window is closed -->
  @if (VM.Done; as d) {
    <div class="oep-card oep-nomf__done">
      <h1 class="oep-nomf__h1">{{ d.Title }}</h1>
      <p>{{ d.Body }}</p>
      <div class="oep-nomf__actions oep-nomf__actions--done">
        @if (d.CanChange) {
          <button type="button" mjButton variant="primary" class="oep-nomf__btn" [disabled]="Busy" (click)="EditNomination()">Edit nomination</button>
          <button type="button" mjButton variant="outline" class="oep-nomf__btn" [disabled]="Busy" (click)="Withdraw()">Withdraw</button>
        }
        <button type="button" mjButton [variant]="d.CanChange ? 'outline' : 'primary'" class="oep-nomf__btn" (click)="Back()">Back to your sessions</button>
      </div>
    </div>
  }

  <!-- markup.html:720-757: editing -->
  @if (VM.Mode === 'editing') {
    <h1 class="oep-nomf__h1">{{ VM.Title }}</h1>
    <p class="oep-nomf__who">{{ VM.Who }}</p>
    <div class="oep-card oep-nomf__card">
      <!-- markup.html:725 -->
      <div class="oep-nomf__intro">Thank you for nominating a presenter for an Outstanding Emerging Presenters award. This form is read by your section's OEP committee when selecting winners. Your scores and comments are never shared with the presenter. Questions: <a href="mailto:service@agu.org">service@agu.org</a>.</div>

      <!-- markup.html:727-740 -->
      @for (b of VM.Rubric; track b.QuestionID) {
        <div class="oep-nomf__block" role="group" [attr.aria-labelledby]="b.HeadingID">
          <h2 class="oep-nomf__q" [id]="b.HeadingID">{{ b.Label }} <span class="oep-nomf__req" aria-hidden="true">*</span></h2>
          <div class="oep-nomf__help" [id]="b.HeadingID + '-help'">{{ b.Help }}</div>
          <agu-scale-choice [Options]="b.Options" [Value]="Answers[b.QuestionID].Level" [Name]="b.Name" [LabelledBy]="b.HeadingID" [Required]="true" [Disabled]="Busy" (ValueChange)="Pick(b.QuestionID, $event)" />
          @if (Answers[b.QuestionID].Level === Outstanding) {
            <span class="oep-nomf__sr" [id]="b.HeadingID + '-just'">Justification</span>
            <textarea class="oep-textarea oep-nomf__justify" [attr.aria-labelledby]="b.HeadingID + ' ' + b.HeadingID + '-just'" aria-required="true"
              placeholder="Justify the outstanding rating in two to four sentences." [(ngModel)]="Answers[b.QuestionID].Justification" [readonly]="Busy" [attr.aria-busy]="Busy"></textarea>
          }
        </div>
      }

      <!-- markup.html:742-744 -->
      <h2 class="oep-nomf__q" id="oep-nomf-additional">Additional reasoning for the section committee</h2>
      <div class="oep-nomf__help" id="oep-nomf-additional-help">Please provide additional reasoning (positive or negative about notable strengths or weaknesses) for the section committee to help distinguish presentations with similar scores.</div>
      <textarea class="oep-textarea oep-nomf__additional" aria-labelledby="oep-nomf-additional" aria-describedby="oep-nomf-additional-help"
        placeholder="Additional reasoning for the committee…" [(ngModel)]="Additional" [readonly]="Busy" [attr.aria-busy]="Busy"></textarea>

      <!-- markup.html:746-748 -->
      <div class="oep-nomf__coi">
        <button type="button" role="checkbox" class="oep-nomf__check" [attr.aria-checked]="Attested" [attr.aria-disabled]="Busy" (click)="ToggleAttested()">
          <span class="oep-nomf__box" aria-hidden="true">{{ Attested ? '✓' : '' }}</span>
          <span class="oep-nomf__check-text">I have no conflict of interest with this presenter. Not their adviser, coauthor, or in the same research group.</span>
        </button>
      </div>

      <!-- markup.html:750-753 -->
      <div class="oep-nomf__actions">
        <button type="button" mjButton variant="primary" class="oep-nomf__submit" [disabled]="!CanSubmit" (click)="Submit()">Submit nomination</button>
        <button type="button" class="oep-nomf__cancel" (click)="Back()">Cancel</button>
      </div>
    </div>
  }
  <p class="oep-nomf__status" role="status" aria-live="polite" [attr.data-tone]="FormStatus?.Tone">{{ FormStatus?.Text }}</p>
</section>
}
